import type { ReactElement, ReactNode } from 'react';
import svg from '!!raw-loader!@search/metro/build/maps/nsk.svg';

export default ({ children }: { children: (svg: ReactNode) => ReactElement }): ReactElement => {
    return children(svg);
};
